import { useEffect, useState } from 'react';

import { ReactComponent as NextButton } from '../../../../assets/images/icons/next-button.svg';
import { ReactComponent as PreviousButton } from '../../../../assets/images/icons/previous-button.svg';
import { ButtonsContainer, Container } from './styles';

const itemsPerPageOptionsDefault = [10, 25, 50, 100];

interface IPaginationButton {
  itemsPerPage?: number;
  setItemsPerPage?: React.Dispatch<React.SetStateAction<number>>;
  page?: number;
  setPage?: React.Dispatch<React.SetStateAction<number>>;
  totalItems?: number;
  itemsPerPageOptions?: number[];
}

export const PaginationButtons: React.FC<IPaginationButton> = ({
  itemsPerPage,
  setItemsPerPage,
  page,
  setPage,
  totalItems,
  itemsPerPageOptions = itemsPerPageOptionsDefault
}) => {
  const [isLastPage, setIsLastPage] = useState(false);

  useEffect(() => {
    if (totalItems && itemsPerPage && totalItems < itemsPerPage) {
      setIsLastPage(true);
    } else {
      setIsLastPage(false);
    }
  }, [totalItems]);

  return (
    <Container>
      <select
        id="select"
        onChange={
          setItemsPerPage
            ? (event) => setItemsPerPage(Number(event.target.value))
            : undefined
        }
        value={itemsPerPage}
      >
        {itemsPerPageOptions?.map((item) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </select>
      Página {page}
      <ButtonsContainer>
        <button
          type="button"
          onClick={
            setPage && page && page > 1
              ? () => setPage(page ? page - 1 : 1)
              : undefined
          }
          disabled={page === 1}
        >
          <PreviousButton />
        </button>
        <button
          type="button"
          onClick={
            setPage && !isLastPage
              ? () => setPage(page ? page + 1 : 1)
              : undefined
          }
          disabled={isLastPage}
        >
          <NextButton />
        </button>
      </ButtonsContainer>
    </Container>
  );
};
